import axios from 'axios'
import { URLs } from '../config'

// 일정 PDF 링크발송 — 인증 불필요 비공개 게이트 (`sign` 패턴 준수, Authorization 헤더 미첨부)
const sign = axios.create({
    baseURL: process.env.VUE_APP_API
})

export const link = {
    get: {
        // @Url /v1/auth/link/schedule?pm=...&birthDate=yyyyMMdd
        schedule: async (params) => {
            return await sign.get(
                `${URLs.auth}/link/schedule`, {
                    params: {
                        pm: params.pm,
                        birthDate: params.birthDate
                    }
                }
            )
        },
        // @Url /v1/auth/link/copay?pm=...&birthDate=yyyyMMdd
        copay: async (params) => {
            return await sign.get(
                `${URLs.auth}/link/copay`, {
                    params: {
                        pm: params.pm,
                        birthDate: params.birthDate
                    }
                }
            )
        },
    },
    post: {
        // @Url /v1/auth/link/verify
        verify: async (params) => {
            return await sign.post(
                `${URLs.auth}/link/verify`,
                { pm: params.pm, birthDate: params.birthDate },
                { headers: { 'Content-Type': 'application/json' } }
            )
        },
    },
}



// WEBPACK FOOTER //
// ./src/api/link.js